function initInfiniteScrollSentinels() {
  function initInfiniteScroll(sentinel) {
    const grid = document.getElementById('product-grid');
    if (!grid || sentinel.dataset.infiniteScrollReady === 'true') return;
    sentinel.dataset.infiniteScrollReady = 'true';

    let loading = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !loading) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(sentinel);

    function stop() {
      observer.unobserve(sentinel);
      sentinel.remove();
    }

    function loadNextPage() {
      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl) {
        stop();
        return;
      }

      loading = true;
      sentinel.classList.add('is-loading');

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.getElementById('product-grid');
          const newSentinel = doc.querySelector('.infinite-scroll-sentinel');

          if (newGrid) {
            Array.from(newGrid.children).forEach((item) => {
              grid.appendChild(item);
            });
          }

          if (newSentinel && newSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
          } else {
            stop();
          }
        })
        .catch((error) => {
          console.error('Infinite scroll failed to load next page:', error);
        })
        .finally(() => {
          loading = false;
          sentinel.classList.remove('is-loading');
        });
    }
  }

  document.querySelectorAll('.infinite-scroll-sentinel').forEach(initInfiniteScroll);
}

document.addEventListener('DOMContentLoaded', initInfiniteScrollSentinels);

// Exposed so facets.js can re-arm infinite scroll on the fresh sentinel it
// swaps in after a sort/filter AJAX update — that sentinel is a brand-new
// element with no observer attached, so loading silently stops at page 1
// unless this runs again.
window.initInfiniteScrollSentinels = initInfiniteScrollSentinels;
